// extracted by mini-css-extract-plugin
export default {"root":"SideMenuLeft_root__w8ZMT","root2":"SideMenuLeft_root2__M4lNC","logoPanda":"SideMenuLeft_logoPanda__IR6XX"};